import { render, staticRenderFns } from "./CarouselTemplate.vue?vue&type=template&id=617b6be3&scoped=true&"
import script from "./CarouselTemplate.vue?vue&type=script&lang=js&"
export * from "./CarouselTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTemplate.vue?vue&type=style&index=0&id=617b6be3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b6be3",
  null
  
)

export default component.exports